<app-information [message]="localService.info" [isRedAlert]="localService.isRedAlert"></app-information>
<app-internet-check></app-internet-check>
<div class="{{localService.selectedLanguageCode}} row freeze_height header_content"
  [ngClass]="isShowNotificationBar ? 'show_blur' : ''"
  *ngIf="localService.languageContent && localService.languages && localService.languageContent.common && !localService.isDirectUrlWithLogin() && !localService.isDirectUrl()"
  style="line-height:15px;z-index: 10;position: sticky;" (window:resize)="onResize($event)">
  <i class="material-icons" id="last_url_save" style="display:none;" (click)="onLastUrlSave()">replay_circle_filled</i>
  <div class="col-md-12" class="header_banner">
    <div style="float:left;" id="header_left">
      <button class="button_icon button_icon_color" *ngIf="localService.selected.user != '' || localService.publicMenus"
        id="menu" (click)="onMenuClicked()">menu</button>
      <span
        [ngStyle]="{'top': localService.selected.user != '' || localService.publicMenus ? '-10px' : '7px', 'color' : (localService.isPrimaryServiceDown ? 'inherit' : 'inherit') }"
        style="color:lightslategray; text-decoration: none; font-weight: bold;position: relative;"
        title="{{(environmentName == 'Production' ? localService.languageContent.common.title : environmentName) + ' - ' +server}}">{{localService.languageContent.common.title}}</span>
    </div>
    <app-working-as *ngIf="localService.selected.user != '' && localService.basicParams"
      [userId]="localService.basicParams.userId" [businessId]="localService.basicParams.businessId"
      [countryCode]="localService.basicParams.countryCode"
      [businessIdAsCustomer]="localService.basicParams.businessIdAsCustomer"></app-working-as>
    <div style="float:right" id="header_right">
      <button class="button_icon button_icon_color" *ngIf="localService.selected.user != ''"
        (click)="onShowHideNotification()">notifications</button>
      <span *ngIf="localService.selected.user != '' && notifications.length > 0" class="en notification_cnt"
        (click)="onShowHideNotification()">{{notifications.length < 10 ? 0 : '' }}{{notifications.length> 99 ? '99+' :
          notifications.length }}</span>
      <div *ngIf="localService.selected.user != '' && notifications.length > 0 && isShowNotificationBar"
        id="notification" [ngStyle]="{'max-height' : notificationHeight + 'px'}">
        <div style="text-align:right;height:30px;">
          <span class="button"
            (click)="onMarkAsRead('A')">{{localService.languageContent.common.mark_all_as_read}}</span>
        </div>
        <div class="notification_bar" *ngFor="let notification of notifications">
          <div [innerHTML]="notification.v1"></div>
          <div class="notification_date en">
            <i class="material-icons notification_cancel" *ngIf="!notification.isReadonly"
              (click)="onMarkAsRead(notification.key)">cancel</i>
            <app-spinner *ngIf="notification.isReadonly"></app-spinner>
            <span>{{ notification.v2 | localDate}}</span>
            <a routerLink="../{{notification.v4}}" class="material-icons button route_navigation"
              (click)="onMarkAsRead(notification.key,true)">subdirectory_arrow_right</a>
          </div>
        </div>
      </div>
      <div style="float: left;width: 200px;margin-right: 10px;margin-top: -6px;"
        *ngIf="localService.countryCodes && localService.basicParams && [InteractionType.Bill_PnixSoft, InteractionType.Auditor].includes(localService.basicParams.interactionType)">
        <ngx-select [(ngModel)]="localService.asCtryCode" [optionValueField]="'v2'" [optionTextField]="'v1'"
          [items]="localService.countryCodes" [noAutoComplete]="true" (select)="onAsCountryChange()"
          [disabled]="localService.asCtryCode != '' && localService.countryCodes.length == 1">
        </ngx-select>
      </div>
      <button class="button_icon button_icon_color" (click)="onCopyUrl()">share</button>
      <button class="button_icon button_icon_color" (click)="onRoute(2)">help</button>
      <button class="button_icon button_icon_color" (click)="onRoute(1)">qr_code_scanner</button>
      <button class="button_icon button_icon_color" (click)="openLanguagSelection()"
        [id]="elementIds.btn_change_language" *ngIf="localService.languages.length > 1">translate</button>
      <button class="button_icon button_icon_color" [id]="elementIds.btn_login_logout" (click)="onLoginLogout(true)">{{
        localService.viewAsReturnCountryCodeUserId ? 'visibility' : localService.selected.user == '' ?
        'lock' : 'lock_open'}}</button>
    </div>
  </div>
  <div class="col-md-12" style="height:45px;">
    &nbsp;
  </div>
</div>
<div id="menu_options_icon" *ngIf="!isShowMenuList && localService.windowWidth > 900 && !localService.isDirectUrl()"
  (scroll)="scrollHandler($event)">
  <div *ngFor="let item of localService.selected.user != '' ? onGetLoggedMenu() :  localService.publicMenus">
    <div class="vertical_menu_parent_icon" title="{{item.menu.v5}}"
      *ngIf="isMinumumOneMenuAvailable(item.menu.key) && item.menu.v7 == '0'" (click)="onCollapseMenu(item.menu.key)">
      <i class="material-icons menu_icon">{{item.menu.v3}}</i>
    </div>
    <div *ngIf="localService.collapsedMenu.indexOf(item.menu.key) == -1">
      <div *ngFor="let itemSub of item.subMenus">
        <div id="{{itemSub.menu.key}}" class="vertical_menu_child_icon"
          [ngClass]="localService.selectedMenu && localService.selectedMenu.key == itemSub.menu.key ? 'selected_menu' : ''"
          (click)="onMenuClicked(itemSub.menu)"
          *ngIf="itemSub.menu.v7 == '0' && itemSub.menu.isSelected && (itemSub.menu.v4 != '#Login#' && itemSub.menu.v4 != '#Logout#')"
          title="{{itemSub.menu.v5}}">
          <i class="material-icons menu_icon">{{itemSub.menu.v3}}</i>
        </div>
      </div>
    </div>
    <div class="dummy" *ngIf="isMinumumOneMenuAvailable(item.menu.key) && item.menu.v7 == '0'">
      &nbsp;
    </div>
  </div>
</div>
<div id="menu_options" class="vertical_menu {{localService.selectedLanguageCode}}"
  *ngIf="isShowMenuList && !localService.isDirectUrl()" (scroll)="scrollHandler($event)">
  <div class="row" style="position: fixed;background-color: white;padding: 0px;margin: 0px;z-index: 1;"
    [ngStyle]="{'width' : searchBoxWidth+'px'}">
    <div class="col-12">
      <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="searchKey"
        title="{{localService.languageContent.common.search}}" id="{{elementIds.txt_search_key}}"
        placeholder="{{localService.languageContent.common.search}}" (input)="onFilterMenu()" />
    </div>
  </div>
  <div style="margin-top: 30px;">
    <div *ngFor="let item of menusToDisplay">
      <div class="vertical_menu_parent" *ngIf="isMinumumOneMenuAvailable(item.menu.key) && item.menu.v7 == '0'"
        (click)="onCollapseMenu(item.menu.key)">
        <i class="material-icons menu_icon">{{item.menu.v3}}</i>
        <span>{{item.menu.v5}}</span>
        <span *ngIf="localService.selected.user != '' && item.menu.v4 == '#UserName#'" class="en">&nbsp;-&nbsp;</span>
        <span *ngIf="localService.selected.user != '' && item.menu.v4 == '#UserName#'"
          [ngClass]="localService.getLanguageCode(localService.loggedMember.loggedMember.content.v5)">
          {{localService.loggedMember.loggedMember.content.v1}}
        </span>
      </div>
      <div *ngIf="localService.collapsedMenu.indexOf(item.menu.key) == -1">
        <div *ngFor="let itemSub of item.subMenus">
          <div id="{{itemSub.menu.key}}" class="vertical_menu_child"
            [ngClass]="localService.selectedMenu && localService.selectedMenu.key == itemSub.menu.key ? 'selected_menu' : ''"
            (click)="onMenuClicked(itemSub.menu)"
            *ngIf="itemSub.menu.v7 == '0' && itemSub.menu.isSelected && (itemSub.menu.v4 != '#Login#' && itemSub.menu.v4 != '#Logout#')">
            <i class="material-icons menu_icon">{{itemSub.menu.v3}}</i>
            <span>{{itemSub.menu.v5}}</span>
          </div>
        </div>
      </div>
      <div class="dummy" *ngIf="isMinumumOneMenuAvailable(item.menu.key) && item.menu.v7 == '0'">
        &nbsp;
      </div>
    </div>
  </div>
  <i class="material-icons scrollTopMenu" *ngIf="lastScroll > 50" (click)="onSetToTop()">arrow_circle_up</i>
  <div class="version">
    <span class="en">Version {{version}}</span>
  </div>
</div>
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
  <input type="button" id="on_page_key_pressed" (click)="onPageKeyPressed()" />
  <input type="button" class="on-login" (click)="onGetBusiness()" />
</span>

<div>
  <app-language-selection [(isOpenPopup)]="isOpenLanguageSelection" [isShowAll]="isShowAllLanguageSelection"
    (onClose)="onCloseLanguageSelection($event)"></app-language-selection>
  <app-login [(isOpenPopup)]="isOpenLogin" (onClose)="onCloseLogin($event)"></app-login>

  <div>
    <span style="display: none;">
      <button id="btnCloseUserAuthenticationFromHeader"
        (click)="onCloseUserAuthentication(true)">OnCloseUserAuth</button>
    </span>
    <app-user-authentication [(isOpenPopup)]="isOpenUserAuthentication"
      (onClose)="onCloseUserAuthentication(false,$event)"
      [btnIdToTriggerWhileClose]="'btnCloseUserAuthenticationFromHeader'"></app-user-authentication>
  </div>
  <app-gallery-viewer></app-gallery-viewer>
</div>
<div class="new_bill_submitted banner"
  *ngIf="localService.languageContent && localService.languages && localService.languageContent.common && isShowNewBillAlert">
  {{localService.languageContent.common.order_placed}}&nbsp;
  <button class="button_icon button_icon_color" style="transform: rotate(45deg);color: yellow !important;
    top: 5px !important;" (click)="onCloseAlert()">add_circle_outline</button>
</div>